import toLowerCase from 'utils/toLowerCase';

// tiktok_us behave the same as tiktok
export const isTiKTok = (
  platform: any,
): platform is 'tiktok' | 'tiktok_us' | 'TIKTOK' | 'TIKTOK_US' => {
  return toLowerCase(platform) === 'tiktok' || toLowerCase(platform) === 'tiktok_us';
};

export const isTiKTokUpperCase = (platform: any): platform is 'TIKTOK' | 'TIKTOK_US' => {
  return platform === 'TIKTOK' || platform === 'TIKTOK_US';
};

export const tiktokLabel = (platform: string) => {
  return platform === 'Tiktok_us' ? 'TikTok US' : platform;
};
